import { camelToSnakeCase, snakeToCamelCase } from "../string";
export const transformObjectDeep = (object, keyValueTransformer, objectPreProcessor) => {
    if (objectPreProcessor && typeof objectPreProcessor === "function") {
        object = objectPreProcessor(object);
    }
    if (Array.isArray(object)) {
        return object.map((obj) => transformObjectDeep(obj, keyValueTransformer, objectPreProcessor));
    }
    else if (object === null || typeof object !== "object") {
        return object;
    }
    return Object.fromEntries(Object.entries(object).map(([key, value]) => keyValueTransformer(key, transformObjectDeep(value, keyValueTransformer, objectPreProcessor))));
};
export const keysToCamelCase = (object) => transformObjectDeep(object, (key, value) => [snakeToCamelCase(key), value]);
export const keysToSnakeCase = (object) => transformObjectDeep(object, (key, value) => [camelToSnakeCase(key), value]);
//# sourceMappingURL=object.js.map